module.exports = __webpack_public_path__ + "static/media/16_l_lampa_16.98_7.87.b270b53f.png";